import React, { useState, useEffect } from 'react';
import App from './App';
import { getCifUrl } from './utils';

export default function RootLoader() {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = getCifUrl();
    script.async = true;
    script.onload = () => setScriptLoaded(true);
    script.onerror = () => {
      // Still load the app for taking calls
      setScriptLoaded(true);
      // Display warning message
      console.error('CIF failed to load');
    };
    document.head.appendChild(script);
  }, []);

  return scriptLoaded ? <App /> : <h2>Loading ...</h2>;
}
